export async function fetchJSON(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const abort = () => controller.abort();
    if (options.signal?.aborted) controller.abort();
    else options.signal?.addEventListener('abort', abort, {once: true});
    try {
        const response = await fetch(url, {...options, signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer'});
        if (!response.ok) throw Object.assign(new Error(`Request failed: ${response.status}`), {status: response.status});
        return await response.json();
    } finally {
        clearTimeout(timeout);
        options.signal?.removeEventListener('abort', abort);
    }
}
export function contentEndpoint(base, path) {
    const url = new URL(base);
    if (url.protocol !== 'https:' || url.username || url.password) throw new Error('Content API requires an HTTPS origin');
    return new URL(path, url.origin);
}
export function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
}
export function icon(src, size) {
    const node = element('img', 'theme-icon');
    node.src = src; node.alt = ''; node.width = size; node.height = size;
    return node;
}
